<template>
  <form novalidate @submit.prevent="submit">
    <v-text-field
      v-model="formData.title"
      v-validate="'required|min:10'"
      :error-messages="errors.collect('Title')"
      label="Title"
      data-vv-name="Title"
      required
    ></v-text-field>
    <issue-desc class="mt-2 mb-4"
      :value="desc"
      label="Description"
      @change="onDescChange"
      hide-actions
    ></issue-desc>
    <v-menu
      v-model="dateMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="formData.date"
          v-validate="'required'"
          :error-messages="errors.collect('Date')"
          label="Start Date"
          data-vv-name="Date"
          required readonly
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker v-model="formData.date"
        :min="today"
        @input="dateMenu = false"></v-date-picker>
    </v-menu>
    <v-row>
      <v-col class="py-0" cols="6">
        <v-select
          label="Priority"
          v-model="formData.priority"
          :items="priorities"
        ></v-select>
      </v-col>
      <v-col class="py-0" cols="6">
        <v-select
          label="Status"
          v-model="formData.status"
          :items="states"
        ></v-select>
      </v-col>
    </v-row>
    <div class="mt-5 d-flex">
      <v-spacer></v-spacer>
      <span v-if="!saving">
        <v-btn depressed text type="reset" @click="close">Cancel</v-btn>
        <v-btn depressed color="accent" class="ml-2" type="submit">Save</v-btn>
      </span>
      <v-btn depressed color="accent" class="ml-2" disabled v-if="saving">
        <v-progress-circular indeterminate size="12" width="1" class="mr-1"></v-progress-circular>
        <span>Saving...</span>
      </v-btn>
    </div>
  </form>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import types from '@/store/types';

export default {
  name: 'project-issue-form',

  $_veeValidate: {
    validator: 'new',
  },

  props: {
    extraData: {
      default() {
        return {};
      },
    },
    formData: {
      type: Object,
      default() {
        return {
          date: new Date().toISOString().slice(0, 10),
          desc: '',
          status: 'open',
          priority: 'major',
        };
      },
    },
  },

  data: () => ({
    today: new Date().toISOString().slice(0, 10),
    dateMenu: false,
    saving: false,
    desc: '',
    dictionary: {
      attributes: {
        title: 'Issue Name',
      },
    },
  }),

  computed: {
    ...mapState([
      'priorities',
      'states',
    ]),
    endpoint() {
      return this.formData.id ? 'updateTask' : 'addTask';
    },
    user() {
      return this.$store.state.user;
    },
    reporter() {
      const { displayName, uid, photoURL } = this.user;
      return {
        displayName,
        uid,
        photoURL,
      };
    },
  },

  mounted() {
    this.$validator.localize('en', this.dictionary);
  },

  created() {
    this.desc = this.$sanitize(this.formData.desc);
  },

  methods: {
    ...mapActions('db', {
      addTask: types.CREATE_ISSUE,
      updateTask: types.UPDATE_ISSUE,
    }),
    onDescChange($event) {
      this.formData.desc = this.$sanitize($event);
    },
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.saving = true;
          const payload = {
            ...this.formData,
            ...this.extraData,
          };
          if (!payload.reporter || !payload.reporter.uid) {
            payload.reporter = {
              ...this.reporter,
            };
          }
          this[this.endpoint](payload).then(
            (res) => {
              this.$emit('save', {
                id: res.id,
                ...payload,
              }, !this.formData.id);
            },
          ).catch((err) => {
            console.log('err', err);
          }).finally(() => {
            this.saving = false;
          });
        }
      });
    },
    close() {
      this.$emit('close');
    },
    clear() {
      this.$validator.reset();
    },
  },
};
</script>
